export const EMAIL_IN_USE_ERROR_MESSAGE = 'Email already in use';
export const GENERAL_ERROR_MESSAGE = 'Error registering for Headliner';
